import { Component, Input, OnInit } from '@angular/core';

import { IncorrectExercise } from '@df/interfaces';
import { TaskTypes } from '../individual.constants';

@Component({
    selector: 'app-individual-data-error',
    templateUrl: './individual-data-error.component.html',
    styleUrls: ['./individual-data-error.component.scss']
})
export class IndividualDataErrorComponent implements OnInit {
    @Input() studentIncorrectExercisesGroup: IncorrectExercise[];

    TaskTypes = TaskTypes;

    getCorrectAnswers(incorrectExercise) {
        if (!incorrectExercise) {
            return '';
        }
        return incorrectExercise.exercise_correct_answers.map(a => a.shortAnswer).join(', ');
    }

    ngOnInit() {
        if (this.studentIncorrectExercisesGroup[0].exercise_type === this.TaskTypes.EXERCISE_MAGIC_BOX) {
            this.processMagicBox();
        }
    }

    processMagicBox() {
        this.studentIncorrectExercisesGroup.forEach(e => {
            e._exercise_text = JSON.parse(e.exercise_text);
            e._shortAnswer = JSON.parse(e.shortAnswer);
            e.exercise_correct_answers.forEach(ca => {
                ca._shortAnswer = JSON.parse(ca.shortAnswer);
            });
        });
    }

    getMagicBoxCellRight(exercise, row, column) {
        return exercise.exercise_correct_answers[0]._shortAnswer[row][column];
    }

    getMagicBoxCellWrong(exercise, row, column) {
        return exercise._shortAnswer[row][column];
    }

    compareMagicBoxAnswers(exercise, row, column) {
        if (exercise._shortAnswer[row][column] === exercise.exercise_correct_answers[0]._shortAnswer[row][column]) {
            return true;
        }
        return false;
    }

    isMagicBoxDefault(elem) {
        return elem === null;
    }

    getMagicBoxTdStyles(exercise, row, col) {
        const styles = this.getDefaultStyles();
        this.updateTopStyles(styles, exercise, row, col);
        this.updateBottomStyles(styles, exercise, row, col);
        this.updateLeftStyles(styles, exercise, row, col);
        this.updateRightStyles(styles, exercise, row, col);

        return styles;
    }

    getDefaultStyles() {
        return {
            'border-left-wrong': false,
            'border-right-wrong': false,
            'border-top-wrong': false,
            'border-bottom-wrong': false,
            'border-left-right': false,
            'border-right-right': false,
            'border-top-right': false,
            'border-bottom-right': false
        };
    }

    getElem(exercise: IncorrectExercise, row: number, col: number) {
        if (row < 0 || row > exercise._exercise_text.length - 1) {
            return undefined;
        }
        if (col < 0 || col > exercise._exercise_text[row].length - 1) {
            return undefined;
        }
        return exercise._exercise_text[row][col];
    }

    private updateTopStyles(styles, exercise: IncorrectExercise, row: number, col: number) {
        this.processCell(styles, exercise, row, col, row - 1, col, 'border-top-wrong', 'border-top-right');
    }
    private updateBottomStyles(styles, exercise: IncorrectExercise, row: number, col: number) {
        this.processCell(styles, exercise, row, col, row + 1, col, 'border-bottom-wrong', 'border-bottom-right');
    }
    private updateLeftStyles(styles, exercise: IncorrectExercise, row: number, col: number) {
        this.processCell(styles, exercise, row, col, row, col - 1, 'border-left-wrong', 'border-left-right');
    }
    private updateRightStyles(styles, exercise: IncorrectExercise, row: number, col: number) {
        this.processCell(styles, exercise, row, col, row, col + 1, 'border-right-wrong', 'border-right-right');
    }

    private processCell(
        styles,
        exercise: IncorrectExercise,
        row: number,
        col: number,
        compRow: number,
        compCol: number,
        styleWrongName: string,
        styleRightName: string
    ) {
        const elem = this.getElem(exercise, row, col);
        const isCurrentError = elem === null && !this.compareMagicBoxAnswers(exercise, row, col);
        if (isCurrentError) {
            styles[styleWrongName] = true;
            return;
        }
        const isCurrentRight = elem === null && this.compareMagicBoxAnswers(exercise, row, col);

        const cmpElem = this.getElem(exercise, compRow, compCol);

        if (cmpElem === undefined && isCurrentRight) {
            styles[styleRightName] = true;
            return;
        }
        if (cmpElem === undefined) {
            return;
        }

        const isCmpElemError = cmpElem === null && !this.compareMagicBoxAnswers(exercise, compRow, compCol);
        if (isCmpElemError) {
            styles[styleWrongName] = true;
            return;
        }
        const isCmpElemRight = cmpElem === null && this.compareMagicBoxAnswers(exercise, compRow, compCol);
        if (isCmpElemRight || isCurrentRight) {
            styles[styleRightName] = true;
        }
    }
}
